import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, { bookingHref, useMarketingCopy } from "./MarketingShell";
import CapabilityShowcases from "./CapabilityShowcases";
import GrowthPitch from "./GrowthPitch";
import narrative from "./siteNarrativeCopy.json";
import "./LandingJourney.css";
import "./CompanyNarrative.css";

export default function QuantLandingPage() {
  const { language } = useMarketingCopy();
  const copy = (narrative[language] ?? narrative.en).home;
  const seoTitle = copy.seoTitle;
  const seoDescription = language === "en" ? narrative.en.home.seoDescription : copy.description;
  return <MarketingShell variant="voyage">
    <SEOHead title={seoTitle} description={seoDescription} canonicalUrl="https://youwo.ai/" ogImage="https://youwo.ai/brand/youwo-sky-ocean-v1.webp"
      structuredData={{ "@context": "https://schema.org", "@type": "Organization", name: "YouWo", url: "https://youwo.ai/", email: "info@youwo.ai", description: seoDescription }} />
    <main id="main-content" tabIndex={-1} className="voyage-main voyage-business-home">
      <section className="voyage-sky" aria-labelledby="quant-title">
        <div className="voyage-atmosphere" aria-hidden="true"><img src="/brand/youwo-sky-ocean-v1.webp" width="1536" height="1024" alt="" decoding="async" /></div>
        <div className="quant-wrap voyage-hero-copy">
          <h1 id="quant-title">{copy.title}{" "}<br /><em>{copy.accent}</em></h1>
          <p className="quant-lead">{copy.description}</p>
          <div className="quant-cta-row">
            <a className="quant-button" href="/blog#case-studies">{copy.primary}</a>
            <a className="quant-text-link" href={bookingHref} target="_blank" rel="noopener noreferrer">{copy.secondary}</a>
          </div>
        </div>
      </section>
      <GrowthPitch />
      <div className="voyage-depth">
      <div id="why-youwo"><CapabilityShowcases /></div>
      <div className="quant-wrap voyage-product-links"><a href="/product" className="quant-text-link">{copy.productLink}</a></div>
      <section className="quant-wrap outcome-featured" aria-labelledby="featured-case-title">
        <div><p className="narrative-label">{copy.caseLabel}</p><h2 id="featured-case-title">{copy.caseTitle}</h2><p>{copy.caseDescription}</p>
          <a className="quant-text-link" href="/blog/international-business-learning-loop">{copy.caseLink}</a>
        </div>
        <dl className="outcome-metrics">{copy.metrics.map(metric => <div key={metric.label}><dt>{metric.label}</dt><dd>{metric.value}</dd></div>)}</dl>
      </section>
      <section className="quant-wrap outcome-close"><h2>{copy.closeTitle}<br /><span>{copy.closeAccent}</span></h2><a className="quant-button" href={bookingHref} target="_blank" rel="noopener noreferrer">{copy.closeLink}</a></section>
      </div>
    </main>
  </MarketingShell>;
}
